import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError, GetListResponse } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { GetTransfersParams, Transfer } from "../../transfers.types";
import { requestGetTransfersList } from "./getTransfersList.request";

const useGetTransfersList = (
  requestParams: GetTransfersParams,
  options?: QueryOptions<GetListResponse<Transfer>, ApiServiceError<ApiError>>,
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["transfer-admin", "all", requestParams],
    queryFn: async () => await requestGetTransfersList(requestParams),
    ...options,
  });

  return { transfersList: data?.data, meta: data?.meta, ...rest };
};

export default useGetTransfersList;
